var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41,
    height: 48,
    viewBox: "0 0 41 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{clip-rule:evenodd;}.c,.i{fill:#fff;}.d{clip-path:url(#a);}.e{clip-path:url(#b);}.f{clip-path:url(#c);}.g{fill:#f12b5d;}.h{clip-path:url(#e);}.i{font-size:24px;font-family:Avenir-Black, Avenir;font-weight:800;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1495.672-1292a9.181,9.181,0,0,1,3.728,1.509,8.545,8.545,0,0,1,3.334,8.978,8.544,8.544,0,0,1-7.015,6.4,8.517,8.517,0,0,1-9.667-7.535,8.536,8.536,0,0,1,6.7-9.225c.174-.036.346-.087.52-.131Z",
    transform: "translate(-1486.001 1292)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0-341.247H1481.436V-1494H0Z",
    transform: "translate(0 1494)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1482.772-1242.538a5.417,5.417,0,0,1-4.659-2.552,6.029,6.029,0,0,1-1.081-3.464,44.524,44.524,0,0,1,.068-4.886,15.93,15.93,0,0,1,4.27-9.663,14.838,14.838,0,0,1,9.232-4.781,15.315,15.315,0,0,1,15.97,9.466,16.062,16.062,0,0,1,1.288,6.546c-.014,1.11,0,2.219,0,3.329a6.122,6.122,0,0,1-4.433,5.907,3.036,3.036,0,0,1-.783.091q-5.107,0-10.214,0C1489.211-1242.547,1485.991-1242.572,1482.772-1242.538Z",
    transform: "translate(-1477 1268)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1503-1289.083h22.376V-1304H1503Z",
    transform: "translate(-1503 1304)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1763.756 -352.945)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(1770.7 352.945)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-1146.57 -155.861)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1484.44-1293h19.532v19.1H1484.44Z",
    transform: "translate(-339.074 1448.089)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(1763.756 371.463)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-1139.625 -174.379)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1475.934-1269.953h32.485v27.762h-32.485Z",
    transform: "translate(-337.131 1442.825)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1781.756 377.945)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(1782.068 382.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.187 -9.041)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "i",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMember);
export default __webpack_public_path__ + "static/media/addMember.9e35d2c87185de5ceb9e910b42d2724c.svg";
export { ForwardRef as ReactComponent };